module.exports = __webpack_public_path__ + "img/banner-partner.b6026520.jpg";